module.exports = __webpack_public_path__ + "img/solaris-barres-3.71a3cdfc.png";